import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageBreadcrumbComponent } from './page-breadcrumb/page-breadcrumb.component';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { RouterModule } from '@angular/router';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { TasksDrawerComponent } from './tasks-drawer/tasks-drawer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'src/ng-zorro-antd.module';
import { FeedbackStatsComponent } from './feedback-stats/feedback-stats.component';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NoPermissionComponent } from './no-permission/no-permission.component';
import { TopFeedbackUsersComponent } from './top-feedback-users/top-feedback-users.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { QuillModule } from 'ngx-quill';
import { SpeechToTextComponent } from './speech-to-text/speech-to-text.component'
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NotificationComponent } from './notification/notification.component';
import { UserDisplayComponent } from './user-display/user-display.component';

@NgModule({
  declarations: [
    PageBreadcrumbComponent,
    PageLoaderComponent,
    TasksDrawerComponent,
    FeedbackStatsComponent,
    FeedbackListComponent,
    UserProfileComponent,
    PageNotFoundComponent,
    NoPermissionComponent,
    TopFeedbackUsersComponent,
    SpeechToTextComponent,
    NotificationComponent,
    UserDisplayComponent,
 
  ],
  imports: [
    CommonModule,
    RouterModule,
    NzBreadCrumbModule,
    NzSpinModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    InfiniteScrollModule,
    NzDatePickerModule,
    NzProgressModule,
    NgxDocViewerModule,
    NzSelectModule,
    QuillModule.forRoot()
  ],
  exports: [
    PageBreadcrumbComponent,
    PageLoaderComponent,
    TasksDrawerComponent,
    FeedbackStatsComponent,
    FeedbackListComponent,
    UserProfileComponent,
    PageNotFoundComponent,
    NoPermissionComponent,
    TopFeedbackUsersComponent,
    SpeechToTextComponent,
    NgxDocViewerModule,
    NotificationComponent,
    UserDisplayComponent
  ]
})
export class SharedComponentsModule { }
